import React from 'react';
import useWindowSize from '@utils/useWindowHeight';

import SideMenuMain from './SideMenuMain';

interface Props {
    user?: any;
}

const SideMenu: React.FC<Props> = ({ user }) => {
    const { height } = useWindowSize(100);

    return (
        <div className="hover-scroll-overlay-y px-2 my-5 my-lg-5" style={{ height: `${height - 200}px` }}>
            <div className="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold">
                <SideMenuMain user={user} />
            </div>
        </div>
    );
};

export default SideMenu;
